
<div class="form-row buttontup btntop col-sm-12" style="margin-top: 10px;">
  <table *ngIf="!data">
    <tr>
      <td>
        <button class="btn btn-sm" (click)="search()">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn btn-sm" (click)="clear()">Rensa</button>
      </td>
    </tr>
  </table>
  <p>
    <button *ngIf="data" (click)="goBack()" class="btn border" style="margin-left:20px;">Tillbaka</button>
    <button *ngIf="data" (click)="captureScreen()" class="btn border" style="margin-left:20px;">Skapa Pdf</button>
</p>
</div>

<div class="col-xl-11">
  <div class="row">
    <div *ngIf="!data" class="col-md-3">
      <form [formGroup]="matrikelform">


        <mat-expansion-panel class="accordionmargin" [expanded]=true>
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Lilla Matrikeln
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="form-group">
            <label for="institutionTypeId">
              Institutionstyp
            </label>
            <select class="form-control form-control-sm" id="institutionTypeId" formControlName="institutionTypeId">
              <option></option>
              <option *ngFor="let i of institutiontypes" [ngValue]="i.id">{{i.prefix}} - {{i.name}}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="institutionNumber">
              Nummer
            </label>
            <input type="text" class="form-control form-control-sm cap" id="institutionNumber"
              formControlName="institutionNumber">
          </div>

          <div class="form-group">
            <label for="institutionNumber">
              Institutionsnamn
            </label>
            <input type="text" class="form-control form-control-sm cap" id="institutionName"
              formControlName="institutionName">
          </div>

          <div class="form-group">
            <label for="visitingCity">
              Ort
            </label>
            <input type="text" class="form-control form-control-sm cap" id="visitingCity"
              formControlName="visitingCity">
          </div>


          <div class="form-group">
            <label for="districtId">
              Distrikt
            </label>
            <select class="form-control form-control-sm" id="districtId" formControlName="districtId">
              <option></option>
              <option *ngFor="let d of districtlist" [ngValue]="d.id">{{d.shortName}} - {{d.name}}</option>
            </select>
          </div>
        </mat-expansion-panel>
      </form>
    </div>

  <div *ngIf="data" class="container" style="min-width: 1100px;overflow-x:auto;" #contentToConvert>
    <div style="padding:50px;">

    <span class="pull-right">{{timestamp | date:'yyyy-MM-dd HH:mm:ss'}}</span>
    <div class="row">
      <div class="col-md-6" style="margin-left:-15px;"><b>{{data.typeName}} {{data.shortName}}</b></div>
      <div class="col-md-5 mx-2" style="margin-left:-6px;"><b>{{data.parent[0].name}} {{data.parent[0].shortName}}</b></div>
    </div>

    <div class="row">
      <div class="col-md-1">Instituerad:</div>
      <div class="col-md-4">{{data.instituerad | date: 'yyyy-MM-dd'}}</div>
      <div class="col-md-1 mx-2">Logetelefon:</div>
      <div class="col-md-4 mx-2">{{data.phone}}</div>
    </div>

    <div class="row">
      <div class="col-md-1">Installation:</div>
      <div class="col-md-4 mx-2">{{data.installationInterval}}</div>
      <div class="col-md-1" style="margin-left:-6px;">E-post:</div>
      <div class="col-md-4"> {{data.email}}</div>
    </div>

    <div class="row">
      <div class="col-md-1">Möten:</div>
      <div class="col-md-4 mx-2">{{data.meetingInterval}}</div>
      <div class="col-md-1 mx-n1">Swish:</div>
      <div class="col-md-4">{{data.swish}}</div>
    </div>

    <div class="row">
      <div class="col-md-1">Postgiro:</div>
      <div class="col-md-4 mx-2">{{data.bankAccount1}}</div>
      <div class="col-md-1" style="margin-left:-6px;">Bankgiro:</div>
      <div class="col-md-4">{{data.bankAccount2}}</div>
    </div>

    <div class="row">
      <div class="col-md-1">Besöksadress:</div>
      <div class="col-md-4 mx-2"></div>
      <div class="col-md-1" style="margin-left:-6px;">Postadress:</div>
      <div class="col-md-4 mx-2"></div>
    </div>

    <div class="row">
      <div class="col-md-5">{{data.visitingAddress.street}}</div>
      <div class="col-md-5 mx-2" style="margin-left:-6px;">{{data.paymentAddress.street}}</div>
    </div>

    <div class="row">
      <div class="col-md-5">{{data.visitingAddress.city}}</div>
      <div class="col-md-5 mx-2" style="margin-left:-6px;">{{data.paymentAddress.zipCode}} {{data.paymentAddress.city}}</div>
    </div>

    <div class="row">
      <div class="col-md-5"></div>
      <div class="col-md-5 mx-2" style="margin-left:-6px;">{{data.paymentAddress.country}}</div>
    </div>

<div class="border">
    <div *ngFor="let o of data.offices" style="border-top:1px solid #F0F0F0;padding:5px;">
      <div class="row">
        <div class="col-md-1"><b>{{o.abbreviation}}</b></div>
        <div *ngIf="o.title" class="col-md-4">{{o.givenName}} {{o.familyName}}</div>
        <div *ngIf="!o.title" class="col-md-4">{{o.givenName}} {{o.familyName}}</div>
        <div class="col-md-2">Tel bostad:</div><div class="col-md-4">{{o.phone}}</div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-4">{{o.street}}</div>
        <div class="col-md-2">Tel arbete:</div><div class="col-md-4">{{o.phoneWork}}</div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-4">{{o.zipCode}} {{o.city}}</div>
        <div class="col-md-2">Mobiltelefon:</div><div class="col-md-4">{{o.phoneMobile}}</div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-1">E-post:</div>
        <div class="col-md-4">{{o.email}}</div>

      </div>
      <br>
    </div>
  </div>
  </div>
</div>
</div>
</div>
